import React from 'react';
import CustomerGeneralInfo from './strategies/CustomerGeneralInfo';
import DialogModal from '../../../common/DialogModal/DialogModal';

const CustomerClientInfoDialog = ({ customer, show, onHide, editable, onCustomerUpdate, translate }) => (
  <DialogModal
    visible={show}
    onClose={onHide}
    title={`${translate('client_info')} (${customer?.name || translate('no_name')})`}
  >
    {customer && show && (
      <CustomerGeneralInfo editable={editable} customer={customer} onCustomerUpdate={onCustomerUpdate} />
    )}
  </DialogModal>
);

export default CustomerClientInfoDialog;
